import RiseApiSerializer from 'rise-ui/serializers/application.js';

import { underscore } from '@ember/string';

import uiPageConfig from 'rise-ui/config/ui-page.js';

const modelNameToPayloadKey = {
  'node--announcement':    'announcement',
  'node--help_topic_page': 'help-page',
  'node--page':            'page',
  'node--file_gallery':    'file-gallery',
  'file--file':            'file-gallery-file',
  [`node--${uiPageConfig.contentType}`]: 'ui-page',
  'field_storage_config--field_storage_config': 'field',
};
const payloadKeyToModelName = Object.fromEntries(
  Object.entries(modelNameToPayloadKey).map(([ m, p ]) => [ p, m ])
);

/**
 * Base serializer for all ember-data requests to data-admin server
 */
export default class ContentSerializer extends RiseApiSerializer {
  modelNameFromPayloadKey(key) {
    return super.modelNameFromPayloadKey(modelNameToPayloadKey[key] || key);
  }
  payloadKeyFromModelName(modelName) {
    return modelName;
  }
  keyForAttribute(key) {
    key = {
      // localAttributeKey: 'remoteAttributeKey',
    }[key] || key;
    return underscore(key);
  }
}
